import React from 'react'
import { Column } from '@ant-design/charts'
import { Card } from 'antd'
import styled from 'styled-components'

export type Granularity = 'week' | 'month' | 'quarter' | 'year'

export const GRANULARITY_OPTIONS: { label: string; value: Granularity }[] = [
  { label: 'Semaine', value: 'week' },
  { label: 'Mois', value: 'month' },
  { label: 'Trimestre', value: 'quarter' },
  { label: 'Année', value: 'year' },
]

interface VolumePoint {
  period: string
  count: number
}

interface Props {
  data: VolumePoint[]
  granularity: Granularity
  onGranularityChange: (g: Granularity) => void
}

const VolumeOverTime = ({ data, granularity, onGranularityChange }: Props) => {
  const config = {
    data,
    xField: 'period',
    yField: 'count',
    style: { fill: '#1890ff' },
    label: {
      style: {
        fill: '#555',
        fontSize: 11,
      },
    },
  }

  const granularityExtra = (
    <GranularityGroup role="group" aria-label="Granularité du graphique">
      {GRANULARITY_OPTIONS.map(opt => (
        <GranularityButton
          key={opt.value}
          type="button"
          $active={granularity === opt.value}
          aria-pressed={granularity === opt.value}
          onClick={() => onGranularityChange(opt.value)}
        >
          {opt.label}
        </GranularityButton>
      ))}
    </GranularityGroup>
  )

  return (
    <Card
      title="Volumétrie dans le temps"
      extra={granularityExtra}
      style={{ borderRadius: 8 }}
    >
      <Column {...config} height={280} />
    </Card>
  )
}

export default VolumeOverTime

const GranularityGroup = styled.div`
  display: flex;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
`

const GranularityButton = styled.button<{ $active: boolean }>`
  padding: 4px 12px;
  border: none;
  border-right: 1px solid #d9d9d9;
  background: ${({ $active }) => ($active ? '#1890ff' : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : 'rgba(0,0,0,0.65)')};
  cursor: pointer;
  font-size: 13px;
  line-height: 22px;
  transition: all 0.2s;

  &:last-child {
    border-right: none;
  }

  &:hover {
    background: ${({ $active }) => ($active ? '#1890ff' : '#f5f5f5')};
  }
`
